import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from './MutationButton';
import { extendedMutationType } from '../../types';

RevokeDevicesButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
};

RevokeDevicesButton.defaultProps = {
    extraConfirmationMessage: null,
    disabled: false,
    label: null,
    icon: null,
};

function RevokeDevicesButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        disabled,
        label,
    } = props;
    return (
        <MutationButton
            className="revoke-all-button button-bordered button"
            confirmationMessage={confirmationMessage}
            disabled={disabled}
            extendedMutation={extendedMutation}
        >
            <FontAwesomeIcon icon={'fa-x'} />&nbsp;{label}
        </MutationButton>
    );
}

export default RevokeDevicesButton;